var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPointFinishIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 66,
    viewBox: "0 0 40 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_988_12816)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20,
    cy: 64,
    rx: 8,
    ry: 2,
    fill: "black",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 39,
    width: 4,
    height: 27,
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24,
    filter: "url(#filter0_f_988_12816)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 25.5,
    r: 18,
    fill: "black"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 22,
    r: 20,
    fill: "#FA1861"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2667 33C11.9078 33 11.6067 32.8723 11.3635 32.617C11.1212 32.3625 11 32.0469 11 31.6701V14.3299C11 13.9531 11.1212 13.637 11.3635 13.3817C11.6067 13.1272 11.9078 13 12.2667 13H20.355C20.6506 13 20.9144 13.0997 21.1467 13.2992C21.739 13.808 22.0162 14.3324 22.3637 14.89C22.6794 15.3967 23.2524 15.6598 23.8494 15.6598H28.7333C29.0922 15.6598 29.3928 15.7871 29.6352 16.0415C29.8784 16.2969 30 16.613 30 16.9898V27.6292C30 28.006 29.8784 28.3216 29.6352 28.5761C29.3928 28.8314 29.0922 28.9591 28.7333 28.9591L23 29C22 29 21.6189 28.8593 21.3867 28.6598C21.2171 28.5142 21.0925 28.3389 21.013 28.1341C20.9538 27.9816 20.8889 27.8291 20.7847 27.7029L20.5266 27.39C19.9567 26.6993 19.108 26.2992 18.2125 26.2992H14.5333C13.981 26.2992 13.5333 26.7469 13.5333 27.2992V31.6701C13.5333 32.0469 13.4122 32.3625 13.1698 32.617C12.9266 32.8723 12.6256 33 12.2667 33Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_988_12816",
    x: -2,
    y: 3.5,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_988_12816"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_988_12816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 66,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointFinishIcon);
export default __webpack_public_path__ + "static/media/PointFinishIcon.101e832cf7d2fad0a98c82bf86783e52.svg";
export { ForwardRef as ReactComponent };